module.exports = __webpack_public_path__ + "static/media/checkbox_check.8ffc2aa2.svg";